
export const payouts_chirps =
`
with unpivot_result as (
    select *
    from chirps
), filter_year_admin as (
    select *
    from unpivot_result
    where admin2 = ? and YEAR >= ? and YEAR <= ?
), cap as (
    select 
    *,
    case 
        when value > ? then ?
        else value
    end as value_cap
    from filter_year_admin
), agr_cal as(
    select
    case when DEKAD > 18 then YEAR+1 else YEAR end as YEAR_ag,
    case when DEKAD < 19 then DEKAD + 36 else DEKAD end as DEKAD_ag,
    *
    from cap
), intervel as (
    select *
    from agr_cal
    where dekad_ag > ? and dekad_ag < ?
), rain_window as (
    select year_ag,
    sum(value)
 as window_value
    from intervel
    group by year_ag
), trigger_exit as (
    select
    round(percentile_cont(0.142) within group (order by window_value asc))
 as trigger_value,
    round(min(window_value))
 as exit_value
    from rain_window
), w as (
    select *
    from rain_window cross join trigger_exit
    order by year_ag
), payout_raw as (
    select
        *,
        (WINDOW_VALUE - TRIGGER_VALUE)/(EXIT_VALUE - TRIGGER_VALUE) as payout_value
    from w
), payout_sum_early as (
    select
    year_ag,
    case 
        when payout_value < 0 then 0
        when payout_value > 1 then 1
        else payout_value
    end as payout
    from payout_raw
),
intervel_1 as (
    select *
    from agr_cal
    where dekad_ag > ? and dekad_ag < ?
), rain_window_1 as (
    select year_ag,
    sum(value)
 as window_value
    from intervel_1
    group by year_ag
), trigger_exit_1 as (
    select
    round(percentile_cont(0.142) within group (order by window_value asc))
 as trigger_value,
    round(min(window_value))
 as exit_value
    from rain_window_1
), w_1 as (
    select *
    from rain_window_1 cross join trigger_exit_1
    order by year_ag
), payout_raw_1 as (
    select
        *,
        (WINDOW_VALUE - TRIGGER_VALUE)/(EXIT_VALUE - TRIGGER_VALUE) as payout_value
    from w_1
), payout_sum_late as (
    select
    year_ag,
    case 
        when payout_value < 0 then 0
        when payout_value > 1 then 1
        else payout_value
    end as payout
    from payout_raw_1
), intervel_2 as (
    select *
    from agr_cal
    where dekad_ag > ? and dekad_ag < ?
), rolling_window_2 as (
    select year_ag,
    avg(value) over (partition by '' order by YEAR, DEKAD ROWS BETWEEN current row and 1 following)
 as rolling_avg_value
    from intervel_2
), rain_window_2 as(
    select year_ag,
    min(rolling_avg_value)
 as window_value
    from rolling_window_2
    group by year_ag
), trigger_exit_2 as (
    select
    round(percentile_cont(0.142) within group (order by window_value asc))
 as trigger_value,
    round(min(window_value))
 as exit_value
    from rain_window_2
), w_2 as (
    select *
    from rain_window_2 cross join trigger_exit_2
    order by year_ag
), payout_raw_2 as (
    select
        *,
        (WINDOW_VALUE - TRIGGER_VALUE)/(EXIT_VALUE - TRIGGER_VALUE) as payout_value
    from w_2
), payout_rolling_early as (
    select
    year_ag,
    case 
        when payout_value < 0 then 0
        when payout_value > 1 then 1
        else payout_value
    end as payout
    from payout_raw_2
), all_payouts as(
    select
    coalesce(a.year_ag, b.year_ag, c.year_ag) as year_ag,
    coalesce(a.payout, 0) as sum_early,
    coalesce(b.payout, 0) as sum_late,
    coalesce(c.payout,0) as rolling_early
    from payout_sum_early a
    full outer join payout_sum_late b on a.year_ag = b.year_ag
    full outer join payout_rolling_early c on a.year_ag = c.year_ag
), combineRow as(
    select
    year_ag,
    sum(sum_early) as sum_early,
    sum(sum_late) as sum_late,
    sum(rolling_early) as rolling_early
    from all_payouts
    group by year_ag
), output as (
    select
    year_ag,
    sum_early * 0.1 + sum_late * 0.5  as combined_payout,
    sum_early,
    sum_late,
    rolling_early
    from combineRow
)
select * from output
`;

export const payouts_arc =
`
with unpivot_result as (
    select *
    from arc
), filter_year_admin as (
    select *
    from unpivot_result
    where admin2 = ? and YEAR >= ? and YEAR <= ?
), cap as (
    select 
    *,
    case 
        when value > ? then ?
        else value
    end as value_cap
    from filter_year_admin
), agr_cal as(
    select
    case when DEKAD > 18 then YEAR+1 else YEAR end as YEAR_ag,
    case when DEKAD < 19 then DEKAD + 36 else DEKAD end as DEKAD_ag,
    *
    from cap
), intervel as (
    select *
    from agr_cal
    where dekad_ag > ? and dekad_ag < ?
), rain_window as (
    select year_ag,
    sum(value)
 as window_value
    from intervel
    group by year_ag
), trigger_exit as (
    select
    round(percentile_cont(0.142) within group (order by window_value asc))
 as trigger_value,
    round(min(window_value))
 as exit_value
    from rain_window
), w as (
    select *
    from rain_window cross join trigger_exit
    order by year_ag
), payout_raw as (
    select
        *,
        (WINDOW_VALUE - TRIGGER_VALUE)/(EXIT_VALUE - TRIGGER_VALUE) as payout_value
    from w
), payout_sum_early as (
    select
    year_ag,
    case 
        when payout_value < 0 then 0
        when payout_value > 1 then 1
        else payout_value
    end as payout
    from payout_raw
),
intervel_1 as (
    select *
    from agr_cal
    where dekad_ag > ? and dekad_ag < ?
), rain_window_1 as (
    select year_ag,
    sum(value)
 as window_value
    from intervel_1
    group by year_ag
), trigger_exit_1 as (
    select
    round(percentile_cont(0.142) within group (order by window_value asc))
 as trigger_value,
    round(min(window_value))
 as exit_value
    from rain_window_1
), w_1 as (
    select *
    from rain_window_1 cross join trigger_exit_1
    order by year_ag
), payout_raw_1 as (
    select
        *,
        (WINDOW_VALUE - TRIGGER_VALUE)/(EXIT_VALUE - TRIGGER_VALUE) as payout_value
    from w_1
), payout_sum_late as (
    select
    year_ag,
    case 
        when payout_value < 0 then 0
        when payout_value > 1 then 1
        else payout_value
    end as payout
    from payout_raw_1
), intervel_2 as (
    select *
    from agr_cal
    where dekad_ag > ? and dekad_ag < ?
), rolling_window_2 as (
    select year_ag,
    avg(value) over (partition by '' order by YEAR, DEKAD ROWS BETWEEN current row and 1 following)
 as rolling_avg_value
    from intervel_2
), rain_window_2 as(
    select year_ag,
    min(rolling_avg_value)
 as window_value
    from rolling_window_2
    group by year_ag
), trigger_exit_2 as (
    select
    round(percentile_cont(0.142) within group (order by window_value asc))
 as trigger_value,
    round(min(window_value))
 as exit_value
    from rain_window_2
), w_2 as (
    select *
    from rain_window_2 cross join trigger_exit_2
    order by year_ag
), payout_raw_2 as (
    select
        *,
        (WINDOW_VALUE - TRIGGER_VALUE)/(EXIT_VALUE - TRIGGER_VALUE) as payout_value
    from w_2
), payout_rolling_early as (
    select
    year_ag,
    case 
        when payout_value < 0 then 0
        when payout_value > 1 then 1
        else payout_value
    end as payout
    from payout_raw_2
), all_payouts as(
    select
    coalesce(a.year_ag, b.year_ag, c.year_ag) as year_ag,
    coalesce(a.payout, 0) as sum_early,
    coalesce(b.payout, 0) as sum_late,
    coalesce(c.payout,0) as rolling_early
    from payout_sum_early a
    full outer join payout_sum_late b on a.year_ag = b.year_ag
    full outer join payout_rolling_early c on a.year_ag = c.year_ag
), combineRow as(
    select
    year_ag,
    sum(sum_early) as sum_early,
    sum(sum_late) as sum_late,
    sum(rolling_early) as rolling_early
    from all_payouts
    group by year_ag
), output as (
    select
    year_ag,
    sum_early * 0.1 + sum_late * 0.5  as combined_payout,
    sum_early,
    sum_late,
    rolling_early
    from combineRow
)
select * from output
`;

